import { render } from "./OnlineService.vue?vue&type=template&id=384484d9&scoped=true"
import script from "./OnlineService.vue?vue&type=script&lang=js"
export * from "./OnlineService.vue?vue&type=script&lang=js"

import "./OnlineService.vue?vue&type=style&index=0&id=384484d9&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384484d9"]])

export default __exports__